import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_KEY = "ABC123XYZ";

function IconSearch() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
  );
}
function IconHome() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
      <polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
  );
}

export default function CaseStatusPage() {
  const navigate = useNavigate();
  const onBack = () => navigate("/");

  const [caseId, setCaseId]               = useState("");
  const [claimNumber, setClaimNumber]     = useState("");
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [loading, setLoading]             = useState(false);
  const [error, setError]                 = useState("");
  const [caseError, setCaseError]         = useState("");
  const [claimError, setClaimError]       = useState("");
  const [vehicleError, setVehicleError]   = useState("");
  const [data, setData]                   = useState(null);

  /* ── styles ─────────────────────────────────── */
  const s = {
    page: {
      minHeight: "calc(100vh - 58px)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px 16px",
    },

    /* card */
    card: {
      background: "#fff",
      borderRadius: "16px",
      boxShadow: "0 4px 24px rgba(16,24,40,0.09), 0 1px 4px rgba(0,0,0,0.04)",
      border: "1px solid #e5e7eb",
      width: "100%",
      maxWidth: "440px",
      padding: "28px 28px 24px",
      boxSizing: "border-box",
    },

    /* card top */
    cardTop: {
      textAlign: "center",
      marginBottom: "24px",
      paddingBottom: "20px",
      borderBottom: "1px solid #f0f1f3",
    },
    logo: { height: "40px", width: "auto", marginBottom: "14px" },
    cardTitle: {
      fontSize: "20px",
      fontWeight: 700,
      color: "#111827",
      marginBottom: "6px",
    },
    cardSub: {
      fontSize: "13.5px",
      color: "#6b7280",
      lineHeight: 1.6,
    },

    /* fields */
    fieldGroup: { marginBottom: "2px" },
    fieldLabel: {
      display: "block",
      fontSize: "11.5px",
      fontWeight: 700,
      color: "#374151",
      letterSpacing: "0.4px",
      textTransform: "uppercase",
      marginBottom: "6px",
    },
    input: {
      width: "100%",
      padding: "10px 13px",
      borderRadius: "9px",
      border: "1.5px solid #e5e7eb",
      fontSize: "15px",
      color: "#111827",
      background: "#f9fafb",
      outline: "none",
      boxSizing: "border-box",
      WebkitAppearance: "none",
    },
    inputHint: {
      fontSize: "11px",
      color: "#9ca3af",
      marginTop: "4px",
    },
    fieldError: { color: "#dc2626", fontSize: "12px", marginTop: "4px" },

    /* OR divider */
    orDivider: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      margin: "14px 0",
    },
    orLine: { flex: 1, height: "1px", background: "#e5e7eb" },
    orText: {
      fontSize: "10.5px",
      fontWeight: 700,
      color: "#9ca3af",
      letterSpacing: "1px",
      textTransform: "uppercase",
    },

    /* form error */
    formError: {
      background: "#fef2f2",
      border: "1px solid #fecaca",
      borderRadius: "8px",
      color: "#dc2626",
      fontSize: "13px",
      padding: "10px 12px",
      marginTop: "14px",
    },

    /* submit */
    submitBtn: {
      width: "100%",
      padding: "12px",
      background: "#111827",
      color: "#fff",
      fontSize: "15px",
      fontWeight: 700,
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      marginTop: "20px",
    },
    submitBtnDisabled: { opacity: 0.55, cursor: "not-allowed" },

    backLink: { textAlign: "center", marginTop: "16px" },
    backBtn: {
      background: "none", border: "none",
      color: "#9ca3af", fontSize: "13px",
      fontWeight: 500, cursor: "pointer",
    },

    /* ── result card ─────────────────────────── */
    detailCard: {
      maxWidth: "760px",
      width: "100%",
      backgroundColor: "#fff",
      borderRadius: "16px",
      boxShadow: "0 18px 36px rgba(16,24,40,0.10)",
      border: "1px solid #e7e9ee",
      overflow: "hidden",
    },
    detailHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "12px",
      padding: "22px 24px 18px",
      borderBottom: "1px solid #eceff3",
    },
    detailTitle: {
      margin: 0,
      fontSize: "clamp(20px, 4vw, 26px)",
      fontWeight: 700,
      color: "#111827",
    },
    detailBody: { padding: "22px 24px 24px" },
    actionBtn: {
      padding: 0, background: "none", border: "none",
      color: "#2563eb", cursor: "pointer",
      fontSize: "14px", fontWeight: 500,
    },
    statusRow: {
      marginBottom: "18px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "10px",
      flexWrap: "wrap",
    },
    statusLabel: { color: "#6b7280", fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.3px", fontWeight: 600 },
    statusChip: {
      display: "inline-block",
      backgroundColor: "#ecfdf3",
      color: "#067647",
      border: "1px solid #a6f4c5",
      borderRadius: "999px",
      padding: "7px 14px",
      fontWeight: 700,
      fontSize: "13px",
    },
    detailsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: "10px",
    },
    infoCard: {
      border: "1px solid #eceff3",
      borderRadius: "10px",
      padding: "11px 13px",
      backgroundColor: "#fcfcfd",
    },
    infoLabel: { margin: "0 0 4px", color: "#6b7280", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.3px" },
    infoValue: { margin: 0, color: "#111827", fontSize: "16px", lineHeight: 1.3, wordBreak: "break-word" },
    ctaWrap: { marginTop: "16px", marginBottom: "8px" },
    cta: {
      display: "inline-block",
      backgroundColor: "#2563eb", color: "#fff",
      textDecoration: "none", fontWeight: 700,
      borderRadius: "9px", padding: "10px 16px", fontSize: "14px",
    },
    commentsWrap: { marginTop: "20px", borderTop: "1px solid #eceff3", paddingTop: "16px" },
    commentsTitle: { margin: "0 0 12px", fontSize: "clamp(16px, 3vw, 20px)", fontWeight: 700, color: "#111827" },
    commentList: { listStyleType: "none", padding: 0, margin: 0, maxHeight: "320px", overflowY: "auto" },
    commentItem: { padding: "9px 0", borderBottom: "1px solid #eef2f6" },
    commentText: { margin: "0 0 3px", color: "#111827", fontSize: "15px" },
    commentTime: { margin: 0, color: "#9ca3af", fontSize: "12px", fontWeight: 500 },
    emptyComments: { color: "#9ca3af", margin: 0, fontSize: "13px" },
  };

  /* ── handlers ────────────────────────────────── */
  const validateInputs = () => {
    const filled = [caseId, claimNumber, vehicleNumber].filter(v => v);
    if (filled.length !== 1) {
      setError("Please fill in exactly one field — Case ID, Claim Number, or Vehicle Number.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setCaseError(""); setClaimError(""); setVehicleError("");
    if (!validateInputs()) return;
    setLoading(true);
    const params = { authorization: API_KEY };
    if (caseId)        params.caseId       = caseId;
    if (claimNumber)   params.claimNumber   = claimNumber;
    if (vehicleNumber) params.vehicleNumber = vehicleNumber;
    try {
      const response = await axios.get("https://annotation.wimwisure.com/ClaimStatus", { params });
      setData(response.data);
    } catch (err) {
      setError(err.response?.data?.error || "Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setCaseId(""); setClaimNumber(""); setVehicleNumber("");
    setError(""); setCaseError(""); setClaimError(""); setVehicleError("");
    setData(null);
  };

  const handleCaseIdChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 5);
    setCaseError(e.target.value.replace(/\D/g, "") !== e.target.value ? "Only numbers allowed" : "");
    setCaseId(digits); setError("");
  };

  const handleClaimNumberChange = (e) => {
    const raw = e.target.value;
    const digits = raw.replace(/\D/g, "");
    if (raw !== digits) setClaimError("Only numbers allowed");
    else if (digits.length > 23) setClaimError("Max 23 digits");
    else setClaimError("");
    setClaimNumber(digits.slice(0, 23)); setError("");
  };

  const handleVehicleNumberChange = (e) => {
    // strip everything except A-Z and 0-9, then uppercase
    const filtered = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 11);
    setVehicleError("");
    setVehicleNumber(filtered); setError("");
  };

  const handleFocus = (field) => {
    setError("");
    if (field === "case")    setCaseError("");
    if (field === "claim")   setClaimError("");
    if (field === "vehicle") setVehicleError("");
  };

  const stripWrappingQuotes = (t = "") => t.trim().replace(/^["'""'']+|["'""'']+$/g, "");
  const toSentenceCase = (t = "") =>
    t.toLowerCase().replace(/(^\s*[a-z])|([.!?]\s+[a-z])/g, m => m.toUpperCase());
  const formatCommentText = (t = "") => toSentenceCase(stripWrappingQuotes(t));

  const formatDate = (v) => {
    if (!v) return "-";
    const p = new Date(v);
    return Number.isNaN(p.getTime()) ? String(v) : p.toISOString().slice(0, 10);
  };
  const formatDateTime = (v) => {
    if (!v) return "-";
    const p = new Date(v);
    if (Number.isNaN(p.getTime())) return String(v);
    return `${p.toISOString().slice(0, 10)} ${p.toISOString().slice(11, 16)}`;
  };

  const claimDetails = data ? [
    ["Case ID",            data.caseId],
    ["Claim Number",       data.claimNumber],
    ["Vehicle Number",     data.vehicleNumber],
    ["Branch Name",        data.branchName],
    ["Garage Name",        data.garageName],
    ["Customer Name",      data.customerName],
    ["Creation Date",      formatDate(data.creationDate)],
    ["Date of Submission", formatDate(data.dateOfSubmission)],
  ] : [];

  const comments = Array.isArray(data?.comments) ? data.comments : [];

  return (
    <>
      <header className="topbar">
        <div className="topbar-brand">
          <img src="/logo.png" alt="Wimwisure" className="topbar-logo" />
        </div>
        <button className="topbar-back" onClick={onBack}><IconHome /> Home</button>
      </header>

      <div style={s.page}>

        {/* ── Search ── */}
        {!data ? (
          <form onSubmit={handleSubmit} style={s.card}>

            {/* Card top */}
            <div style={s.cardTop}>
              <img src="/logo.png" alt="Wimwisure" style={s.logo} />
              <p style={s.cardTitle}>Check Claim Status</p>
              <p style={s.cardSub}>
                Enter any one identifier below to see your claim's current stage and recent updates.
              </p>
            </div>

            {/* Vehicle Number */}
            <div style={s.fieldGroup}>
              <label style={s.fieldLabel}>Vehicle Number</label>
              <input
                type="text" inputMode="text"
                placeholder="e.g. MH12AB1234"
                value={vehicleNumber}
                onFocus={() => handleFocus("vehicle")}
                onChange={handleVehicleNumberChange}
                style={s.input}
              />
              {vehicleError
                ? <p style={s.fieldError}>{vehicleError}</p>
                : <p style={s.inputHint}>Letters and numbers only, no spaces or dashes</p>}
            </div>

            <div style={s.orDivider}>
              <span style={s.orLine} /><span style={s.orText}>or</span><span style={s.orLine} />
            </div>

            {/* Claim Number */}
            <div style={s.fieldGroup}>
              <label style={s.fieldLabel}>Claim Number</label>
              <input
                type="text" inputMode="numeric"
                placeholder="e.g. 28010024010000123456"
                value={claimNumber}
                onFocus={() => handleFocus("claim")}
                onChange={handleClaimNumberChange}
                style={s.input}
              />
              {claimError
                ? <p style={s.fieldError}>{claimError}</p>
                : <p style={s.inputHint}>From your insurance document</p>}
            </div>

            <div style={s.orDivider}>
              <span style={s.orLine} /><span style={s.orText}>or</span><span style={s.orLine} />
            </div>

            {/* Case ID */}
            <div style={s.fieldGroup}>
              <label style={s.fieldLabel}>Case ID</label>
              <input
                type="text" inputMode="numeric"
                placeholder="e.g. 20908"
                value={caseId}
                onFocus={() => handleFocus("case")}
                onChange={handleCaseIdChange}
                style={s.input}
              />
              {caseError
                ? <p style={s.fieldError}>{caseError}</p>
                : <p style={s.inputHint}>Numeric case ID, up to 5 digits</p>}
            </div>

            {error && <div style={s.formError}>{error}</div>}

            <button
              type="submit"
              disabled={loading}
              style={{ ...s.submitBtn, ...(loading ? s.submitBtnDisabled : {}) }}
            >
              <IconSearch />
              {loading ? "Searching…" : "Check Claim Status"}
            </button>

            <div style={s.backLink}>
              <button type="button" onClick={onBack} style={s.backBtn}>
                ← Back to Home
              </button>
            </div>
          </form>

        ) : (

          /* ── Result ── */
          <div style={s.detailCard}>
            <div style={s.detailHeader}>
              <h2 style={s.detailTitle}>Claim Details</h2>
              <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
                <button onClick={reset} style={s.actionBtn}>New Search</button>
                <button onClick={onBack} style={{ ...s.actionBtn, color: "#6b7280", display:"flex", alignItems:"center", gap:"5px" }}><IconHome /> Home</button>
              </div>
            </div>

            <div style={s.detailBody}>
              <div style={s.statusRow}>
                <span style={s.statusLabel}>Current Status</span>
                <span style={s.statusChip}>{data.currentStatus || "-"}</span>
              </div>

              <div style={s.detailsGrid}>
                {claimDetails.map(([label, value]) => (
                  <div key={label} style={s.infoCard}>
                    <p style={s.infoLabel}>{label}</p>
                    <p style={s.infoValue}>{value || "-"}</p>
                  </div>
                ))}
              </div>

              {data.currentStage === 5 && (
                <div style={s.ctaWrap}>
                  <a href="https://claim.wimwisure.com/login"
                    target="_blank" rel="noopener noreferrer" style={s.cta}>
                    Download Assessment Report
                  </a>
                </div>
              )}

              <div style={s.commentsWrap}>
                <h3 style={s.commentsTitle}>Recent Updates</h3>
                {comments.length === 0 ? (
                  <p style={s.emptyComments}>No updates available yet.</p>
                ) : (
                  <ul style={s.commentList}>
                    {comments.map((c, i) => (
                      <li key={i} style={s.commentItem}>
                        <p style={s.commentText}>{formatCommentText(c.comment)}</p>
                        <p style={s.commentTime}>{formatDateTime(c.commentTime)}</p>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
